<div class="col box-contain asistencias-detalle">
    <div class="col-xs-12 p0"></div>
    <div class="detalle-asistencias">
        <div class="panel-group" id="asistencias" role="tablist" aria-multiselectable="true">
            <div class="panel panel-default">
                <div class="panel-heading" id="heading1" role="tab">
                    <h4 class="panel-title">
                        <a class="ver-detalle-coberturas collapsed" id="ver-todas-las-coberturas" role="button" data-toggle="collapse" data-parent="#asistencias" href="#collapseCoberturas" aria-expanded="true" aria-controls="collapseCoberturas" (click)='logEventVerAsistencias()'>MIS ASISTENCIAS - {{poliza.tipoAsistencia}}</a>
                    </h4>
                </div>
                <div class="panel-collapse collapse" id="collapseCoberturas" role="tabpanel" aria-labelledby="heading1" aria-expanded="false">
                    <div class="panel-body">
                        <div class="panel-group" id="accordion">
                            <div class="panel-heading__title">
                                <div class="panel-heading__title-content">
                                    <h4>DETALLE ASISTENCIA</h4>
                                    <h4>EVENTOS POR AÑO</h4>
                                </div>
                            </div>
                            <div class="panel panel-default" *ngFor='let asistencia of asistencias; let i = odd'>
                                <div class="panel-heading">
                                    <h4 class="panel-title">
                                        <a [ngClass]="{'bg-gray': i}" class="accordion-toggle link-accordion collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse{{asistencia.idAsistencia}}">
                                            <div class="link-accordion__img"><img src="/assets/img/{{asistencia.imageName}}" alt="SURA ICON REMOLQUE" />
                                                <p>{{asistencia.name}}</p>
                                            </div>
                                            <p class="link-accordion__tope" id="topeAsistencia">{{asistencia.top}}</p>
                                        </a>
                                    </h4>
                                </div>
                                <div class="panel-collapse collapse" id="collapse{{asistencia.idAsistencia}}">
                                    <div class="panel-body">
                                        <p [innerHTML]="asistencia.text"></p>
                                        <p *ngIf="asistencia.restrictions.length > 0"><strong>Condiciones y restricciones de la cobertura:</strong></p>
                                        <div class="coberturas" *ngFor='let restriction of asistencia.restrictions; let i = odd'>
                                            <div class="coberturas-row" [ngClass]="{'bg-gray': i}">
                                                <p>{{restriction.text1}}</p>
                                                <p>{{restriction.text2}}</p>
                                            </div>
                                        </div>
                                        <p><strong>Tope de cobertura(UF): {{asistencia.top}}</strong></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- end container-->
    <div class="col-xs-12" style="padding: 0;">
        <div class="alert-info"><img src="/assets/img/sura-icon-info.svg" alt="SURA ICON INFO" />
            <p>Si planeas viajar al extranjero en tu auto recuerda avisarnos a <a href="mailto:cliente@segurossura.cl">cliente@segurossura.cl</a> para detener los cobros.</p>
        </div>
    </div>
</div>